import * as React from 'react';

const ServiceContext = React.createContext({
  activeService: 'pagination',
  setActiveService: () => {},
});

export default ServiceContext;
